import storage from '../../../../../hooks/useStorage/useStorage';
import { existsIndexDbToUser } from '../../../../offline/database/offlineDatabase/offlineDatabase';
import { offlineExportMultipleOrdersCsv } from '../../../../offline/offlineRequestAdapters/onlineOrder.repository.offlineAdapters';
import { offlineOrdersRepository } from '../../../../offline/repositories/offlineOrders.repository';
import { ExportMultipleCsvParams } from '../../../list/mass-actions/types/orderListMassActions.types';
import { OrderListTabName, getOrderStatusByTab } from '../../../list/orderListTabs';
import { exportMultipleOrdersCsv } from '../../../repositories/ordersRepository/onlineOrdersRepository';
import { defaultMultipleOrdersFilename } from './exportOrder.utils';

interface ExportOrdersCsvWithOfflineParams {
  paramsToExport: Omit<ExportMultipleCsvParams, 'filename'>;
  selectedIds?: string[];
  selectedTab?: OrderListTabName;
  filterMaxResults?: number;
}

export const exportOrdersCsvWithOffline = async ({
  paramsToExport,
  selectedIds,
  filterMaxResults,
  selectedTab,
}: ExportOrdersCsvWithOfflineParams) => {
  const { translate, searchParams, isOfflineMode } = paramsToExport;
  const brandId = storage.getBrandId() as string;
  const status = getOrderStatusByTab(selectedTab);
  const statusToFilter = searchParams.status ? searchParams.status : status;

  const searchParamsWithStatus = {
    ...searchParams,
    status: statusToFilter.length ? statusToFilter : undefined,
  };

  if (isOfflineMode) {
    return exportMultipleOrdersCsv({
      ...paramsToExport,
      filename: defaultMultipleOrdersFilename(translate, true),
    });
  }

  const canValidateIfNeedExport =
    (await existsIndexDbToUser()) && (await offlineOrdersRepository.hasOrders());

  let offlineCount: number | undefined;

  if (canValidateIfNeedExport) {
    offlineCount = searchParamsWithStatus.ids?.length
      ? await offlineOrdersRepository.countByIds(searchParamsWithStatus.ids)
      : await offlineOrdersRepository.count();

    if (offlineCount) {
      await offlineExportMultipleOrdersCsv({
        ...paramsToExport,
        searchParams: searchParamsWithStatus,
        brandId,
        filename: defaultMultipleOrdersFilename(translate, true),
      });
    }
  }

  const offlineExportedAllByIds =
    selectedIds && offlineCount && offlineCount === selectedIds.length;

  const offlineExportedAllByFilters =
    !selectedIds && filterMaxResults && offlineCount && offlineCount === filterMaxResults;

  const offlineWhenOnlineHasExportedAll =
    offlineCount && (offlineExportedAllByIds || offlineExportedAllByFilters);

  if (offlineWhenOnlineHasExportedAll) {
    return;
  }

  return exportMultipleOrdersCsv({
    ...paramsToExport,
    searchParams: searchParamsWithStatus,
    brandId,
    filename: defaultMultipleOrdersFilename(translate, false),
  });
};
